import * as React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'
// import { FormattedMessage } from 'react-intl';

export interface IHeaderProps {
    current?: string,
}


export default class Header extends React.Component<IHeaderProps, any> {

    public handleClick(index: number) {
        switch (index) {
            case 1:
                location.href = '/'
                break;
            case 2:
                location.href = 'https://www.gg.com'
                // this.scrollTo('ourGame')
                break;
            case 3:
                this.scrollTo('news')
                break;
            case 4:
                location.href = '/aboutUs'
                break;
            case 5:
                location.href = '/joinUs'
                break;
            default:
                break;
        }
    }

    public scrollTo(id: string) {
        const anchorElement = document.getElementById(id);
        if (anchorElement) {
            window.scrollTo({ top: anchorElement.offsetTop, behavior: "smooth" });
        }
    }

    public componentDidMount() {
        const mobile = sessionStorage.getItem('mobile') === 'true' ? true : false
        if (mobile) {
            location.href = '#mobileHome'
        }

        window.addEventListener('resize', this.reset)
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this.reset)
    }
    public reset() {
        let absoultWidth = 1920;
        const oHtml = document.getElementsByTagName('html')[0]
        const width = oHtml.clientWidth;

        if (sessionStorage.getItem('mobile') === 'true') {
            absoultWidth = 375;
            oHtml.style.fontSize = 16 * (width / absoultWidth) + "px";
        } else {
            oHtml.style.fontSize = 16 * (width / absoultWidth) + "px";
        }
    }

    public handleChange(locale: string) {
        // const locale = localStorage.getItem("locale") === 'zh' ? 'en' : 'zh'
        localStorage.setItem("locale", locale)
        window.location.reload()
    }

    public render() {
        return (
            <div className="header-style">
                <div className="logo-style">
                    <img onClick={this.handleClick.bind(this, 1)} src={require("@static/pc/logo.png")} alt="域起官网" />
                </div>
                <div className="menu">
                    <div onClick={this.handleClick.bind(this, 1)}> 首页 </div>
                    {/* <div onClick={this.handleClick.bind(this, 2)}>游戏产品</div>
                    <div onClick={this.handleClick.bind(this, 3)}>新闻资讯</div> */}
                    {this.props.current === 'home'
                        ? (
                            <React.Fragment>
                                <div onClick={this.handleClick.bind(this, 2)}>游戏产品</div>
                                <div onClick={this.handleClick.bind(this, 3)}>新闻资讯</div>
                            </React.Fragment>)
                        : (
                            <React.Fragment>
                                <div><Link to={{ pathname: `/`, state: { location: 'game' } }}>游戏产品</Link></div>
                                <div><Link to={{ pathname: `/news` }}>新闻资讯</Link></div>
                            </React.Fragment>)}
                    <div onClick={this.handleClick.bind(this, 4)}>关于我们</div>
                    <div onClick={this.handleClick.bind(this, 5)}>加入我们</div>
                </div>
                {/* <div className="i18n"><span onClick={this.handleChange.bind(this, 'zh')}>中</span> | <span onClick={this.handleChange.bind(this, 'en')}>EN</span></div> */}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx